import { create } from 'zustand'

interface PopupStore {
  showCompleteProfile: boolean
  setShowCompleteProfile: (show: boolean) => void
}

export const usePopupStore = create<PopupStore>((set) => ({
  showCompleteProfile: false,
  setShowCompleteProfile: (show) => set({ showCompleteProfile: show }),
}))
